import React from 'react'

import './price-table-styles.css'
import DateFormat from '../../shared/helpers/date-format'
import storage from '../../services/storage'
import { attendanceInfo } from '../helpers/calendar'

const { full, dashed } = DateFormat

function PriceTable({
  selectedDate,
  hours,
  planningInfo,
  priceTableInfo,
  setPriceTableInfo,
  isMobiDisplayed
}) {
  if (!selectedDate) {
    return null
  }
  let price
  let attendance
  let bestAdult
  let bestChild
  if (priceTableInfo && Object.keys(priceTableInfo)?.length > 0) {
    price = priceTableInfo['bestPrice']
    attendance = priceTableInfo['projectedAttendance']
    bestAdult =
      priceTableInfo['bestPricingForDay']['nonMember']?.['adult']['types']
    bestChild =
      priceTableInfo['bestPricingForDay']['nonMember']?.['child']['types']
  } else if (!priceTableInfo || Object.keys(priceTableInfo)?.length === 0) {
    setPriceTableInfo(
      planningInfo.find(data => data['date'] === dashed(storage.getItem('day')))
    )
  }

  const populatePriceTable = (bestAdult, bestChild, price, isMobileView) => {
    const gaAdult = `$${parseFloat(bestAdult?.['default']?.['price']).toFixed(
      2
    )}+` // SHEDDWEB-821, added + from end of this line.
    const gaChild = `$${parseFloat(bestChild?.['default']?.['price']).toFixed(
      2
    )}+` // SHEDDWEB-821, added + from end of this line.
    let resAdult = `$${parseFloat(bestAdult?.['chicago']?.['price']).toFixed(
      2
    )}`
    let resChild = `$${parseFloat(bestChild?.['chicago']?.['price']).toFixed(
      2
    )}`
    if (parseInt(bestAdult?.['illinois']?.['price']) === 0) {
      resAdult = 'Free'
      resChild = 'Free'
    }
    const resTitle = `${
      bestAdult?.['chicago']?.['label'] || bestAdult?.['illinois']?.['label']
    }`
    // GA unavailable messaging to render when GA Adult is sold out
    if (isMobileView) {
      return (
        <>
          {price === null && (
            <div>
              <div className={'ga-unavailable'}>
                General Admission unavailable
              </div>
              <div>
                Tickets for programs and events may still be available if
                general admission is sold out. To see what programs and events
                are available for this date, click below to continue.
              </div>
            </div>
          )}
          {price !== null && (
            <div className={'mobile-price-table'}>
              <p className={'font-bold mt-12 mb-4'}>General Admission</p>
              <div className={'price-type-row'}>
                <p>Adults</p>
                <p>{gaAdult}</p>
              </div>
              <div className={'price-type-row'}>
                <p>Children (3-11)</p>
                <p>{gaChild}</p>
              </div>
              <div className={'price-type-row'}>
                <p>Infants</p>
                <p>Free</p>
              </div>

              <p className={'font-bold mt-12 mb-4'}>{resTitle}</p>
              <div className={'price-type-row'}>
                <p>Adults</p>
                <p>{resAdult}</p>
              </div>
              <div className={'price-type-row'}>
                <p>Children (3-11)</p>
                <p>{resChild}</p>
              </div>
              <div className={'price-type-row'}>
                <p>Infants</p>
                <p>Free</p>
              </div>

              <p className={'font-bold mt-12 mb-4'}>Members</p>
              <div className={'price-type-row'}>
                <p>Adults</p>
                <p>Free</p>
              </div>
              <div className={'price-type-row'}>
                <p>Children (3-11)</p>
                <p>Free</p>
              </div>
              <div className={'price-type-row'}>
                <p>Infants</p>
                <p>Free</p>
              </div>
            </div>
          )}
        </>
      )
    } else {
      return (
        <>
          {price === null && (
            <div>
              <div className={'ga-unavailable'}>
                General Admission unavailable
              </div>
              <div>
                Tickets for programs and events may still be available if
                general admission is sold out. To see what programs and events
                are available for this date, click below to continue.
              </div>
            </div>
          )}
          {price !== null && (
            <table>
              <tbody>
                <tr>
                  <th></th>
                  <th>General Admission</th>
                  <th>{resTitle}</th>
                  <th>Members</th>
                </tr>
                <tr>
                  <td>Adults</td>
                  <td>{gaAdult}</td>
                  <td>{resAdult}</td>
                  <td>Free</td>
                </tr>
                <tr>
                  <td>Children (3-11)</td>
                  <td>{gaChild}</td>
                  <td>{resChild}</td>
                  <td>Free</td>
                </tr>
                <tr>
                  <td>Infants</td>
                  <td>Free</td>
                  <td>Free</td>
                  <td>Free</td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      )
    }
  }

  if (isMobiDisplayed) {
    return (
      <div className={'price-table'}>
        <div />
        <div>
          We expect {attendanceInfo(attendance)} attendance on this date.{' '}
          {hours}
        </div>
        {populatePriceTable(bestAdult, bestChild, price, true)}
      </div>
    )
  } else {
    return (
      <div className={'price-table'}>
        <div>You have selected {full(selectedDate)}</div>
        <div>
          We expect {attendanceInfo(attendance)} attendance on this date.{' '}
          {hours}
        </div>
        {populatePriceTable(bestAdult, bestChild, price, false)}
      </div>
    )
  }
}

export default PriceTable
